import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileActionBarContent from "./MobileActionBarContent";

function MobileListActionBar({ children }) {
  const { t } = useTranslation();
  return (
    <MobileActionBarContent>
      <div className="d-flex gap-2 w-100">
        <Link to="/home" className="btn btn-default flex-fill">
          <i className="fa fa-home fa-fw me-1" />
          {t("menu.home")}
        </Link>
        {children}
      </div>
    </MobileActionBarContent>
  );
}

MobileListActionBar.propTypes = {
  children: PropTypes.node,
};

export default MobileListActionBar;
